import './App.css';
import { RouterProvider } from 'react-router-dom';
import router from './router';
import MediaPlayer from '@components/MediaPlayer';

function App() {
  return (
    <>
      <RouterProvider router={router} />
      <MediaPlayer />
    </>
  );
}

export default App;
